import axios from 'axios';
import Qs from 'qs';


// 获取用户下项目列表
export const GetBaseInfo = axiosApi('get', '/project/info');

// 通过项目ID获取项目所有站点
export const GetAreas = axiosApi('get', '/area/project/all');

// 获取能耗同环比
export const GetCompare = axiosApi('get', '/power/compare');

// 获取本年项目能耗
export const GetCurrentPowerInfo = axiosApi('get', '/power/current/year/powerAnalysis');

// 根据区域查询分合闸状态
export const GetCloseAndOpenNum = axiosApi('get', '/area/device/loop/status')

// 根据区域查询当前区域所有电柜数量
export const GetDeviceClassNum = axiosApi('get', '/device/area/class/number');





//***************************************能源管理******************************* */
// 获取今年的能源分析数据
export const GetCurrentYearPowerAnalysis = axiosApi('get', '/power/current/year/powerAnalysis');

// 获取指定时间段内的能源分析数据
export const GetPowerAnalysis = axiosApi('get', '/power/powerAnalysis');

// 获取区域和回路信息
export const GetAreaAndLoop = axiosApi('get', '/area/device/loop/tree/v2');

// 获取区域的成本分析数据
export const GetCostAnalysisForArea = axiosApi('get', '/power/costAnalysis/area');

// 获取回路的成本分析数据
export const GetCostAnalysisForLoop = axiosApi('get', '/power/costAnalysis/loop');

// 获取项目的成本分析数据
export const GetCostAnalysis = axiosApi('get', '/power/costAnalysis');

// 获取负荷分析数据
export const GetLoadAnalysis = axiosApi('get', '/diagram/loop');

// 获取区域的用电量数据(弃用)
export const GetPowerAnalysisForArea = axiosApi('get', '/power/powerAnalysis/area');

// 获取回路的用电量数据
export const GetPowerAnalysisForLoop = axiosApi('get', '/power/powerAnalysis/loop');

// 获取项目下所有的回路
export const GetAllLoop = axiosApi('get', '/loop/all');

// 获取本月最大负荷
export const GetMaxLoadOfMonth = axiosApi('get', '/power/max/val');


// 获取需量分析数据
export const GetDemand = axiosApi('get', '/power/demand');


//***************************************资产管理******************************* */
// 查询项目所有设备,返回树形数据
export const GETDEVICETREE = axiosApi('get', '/device/tree/info');

// 查询项目所有设备
export const GetAllDevices = axiosApi('get', '/device/project/all');


// 根据查询项目中的设备详情
export const GetDevices = axiosApi('get', '/device/project/area/details');

// 获取设备详情
export const GetMoreParam = axiosApi('get', '/device/details');

// 获取接线图
export const GetWiring = axiosApi('get', '/diagram/wiring/tree');


//***************************************报警管理******************************* */
// 查询项目下所有报警
export const GetAlarmList = axiosApi('get', '/alarm/details/infos');

// 报警消息已读
export const GetAlarmNumbers = axiosApi('get', '/alarm/class/number');

// 获取前几天的报警次数 0当天
export const getTodayNumberAlarms = axiosApi('get', '/alarm/num/day');

// 获取前几月的报警次数 0当月
export const getThisMonthNumberAlarms = axiosApi('get', '/alarm/num/month');

//获取报警状态统计次数
export const AlarmStatusNumbers = axiosApi('get', '/alarm/class/number');

//获取设备下报警记录
export const GetDeviceAlarmList = axiosApi('get', '/alarm/infos');

// 获取项目下所有设备，按照设备类型返回
export const GetDevicesTypeByProject = axiosApi('get', '/device/tree/info');

// 获取项目区域下所有设备，按照设备类型返回
export const GetDevicesTypeByArea = axiosApi('get', '/device/project/area/group/class');

// 获取设备下所有回路，按照设备类型返回
export const GetDevicesLoop = axiosApi('get', '/loop/list');

// 获取配置信息
export const GetTemplates = axiosApi('get', '/template/get');

// 获取所有配置信息
export const GetTemplateList = axiosApi('get', '/template/ref/list');

// 获取项目能耗
export const GetPowerInfo = axiosApi('get', '/power/powerAnalysis');


// 获取所有配置信息
export const GetPowerDemand = axiosApi('get', '/power/queryPowerDemand')

// 报警检测获取报警数量年月日
export const GetalarmCount = axiosApi('get', '/alarm/device/num');

// 分页查询设备下报警详细信息
export const GetDeviceAlarmDetails = axiosApi('get', '/alarm/details/device');


//***************************************项目管理******************************* */
// 根据项目区域获取设备详细信息
export const GETDEVICESDETAILS = axiosApi('get', '/device/project/area/details');

// 查询项目中某区域的设备，并根据类别进行分组
export const GETDEVICESBYGROUP = axiosApi('get', '/device/project/area/group/class');

// 根据类别查询项目中的设备
export const GETDEVICESBYCLASS = axiosApi('get', '/device/project/class');



//***************************************用户管理******************************* */
// 获取用户下项目列表
export const GetUserProject = axiosApi('get', '/project/user/all');


// 查询项用户详情信息
export const GetUserInfo = axiosApi('get', '/user/info');

//项目成员模糊查询
export const GetQueryProjectMembers = axiosApi('get', '/user/like/name');

// 查询项目内所有用户
export const GetUserList = axiosApi('get', '/user/project-users');

//获取项目外的所有用户信息
export const ProjectOthersMembers = axiosApi('get', '/user/other/project');

//添加项目成员
export const AddProjectMembers = axiosApi('post', '/user/project/ref');

//更新修改用户信息
export const UpdateMemberInfo = axiosApi('put', '/user/base-info/update');



//***************************************数字孪生******************************* */
//获取所有区域的成本分析
export const GetAllRegionalCost = axiosApi('get', '/power/costAnalysis/all-area');


//获取所有区域的成本分析
export const GetAllAreasPowerAnalysis = axiosApi('get', '/power/areas/analysis');

//根据项目设备在线数量
export const GetDeviceNumber = axiosApi('get', '/device/all/number')


const url = 'https://local.vrmaker.vip:37086'//公司线上服务器
// const url = 'https://localhost:8989'//本地服务器
// const url= 'http://123.57.60.60:37086',//线上服务器

/**
 * 用Create方法来创建axios请求对象
 */

export const INITAXIOS = axios.create({
    timeout: 20000, // 请求超时时间
    baseURL: url,//线上公司服务器
    method: 'post',
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
    },
    transformRequest: data => {
        let result = Qs.stringify(data);
        return result
    },
    transformResponse: data => {

        let result = JSON.parse(data);
        const { code } = result
        if (code == 401) {
            console.log(result)
            reloginToSetToken()
        } else {
            return result || ' ';
        }
    }
})

function reloginToSetToken() {
    Login({ tel: global.tel, psw: global.psw }).then(({ data }) => {
        const { status, msg } = data
        const tips = msg;
        if (status) {
            const { user, token } = data.data
            setToken(token);
        } else {
            console.log(tips)
        }

    }).catch(err => {
        console.log(err)
    })
}

export function setToken(token) {
    //TOKEN = token;
    global.token = token;
}
/**
 * 用来创建普通请求方法
 * @param api
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, header) {
    header ? header : header = {};
    return data => {
        switch (type) {
            case 'get':
                return INITAXIOS({
                    url: api,
                    params: data,
                    method: 'get',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'post':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'post',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'put':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'put',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'delete':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'delete',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
        }
    }
}